import CoolenMainPage from "@/pages/comp/coolen/main";

const routerArr:object[] = [
  {
    path: "/comp/coolen/main",
    element: <CoolenMainPage></CoolenMainPage>,
  },
];

export default routerArr;